import { render, staticRenderFns } from "./CompBookSpaceInfo.vue?vue&type=template&id=568f32d6&scoped=true"
import script from "./CompBookSpaceInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CompBookSpaceInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f32d6",
  null
  
)

export default component.exports